import { render, staticRenderFns } from "./copy3.vue?vue&type=template&id=60aaa0b2&scoped=true"
import script from "./copy3.vue?vue&type=script&lang=js"
export * from "./copy3.vue?vue&type=script&lang=js"
import style0 from "./copy3.vue?vue&type=style&index=0&id=60aaa0b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60aaa0b2",
  null
  
)

export default component.exports